import axios from 'axios';

export const http = axios.create({
  baseURL: process.env.VUE_APP_SOLKART_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// https://github.com/axios/axios/issues/2190.
http.interceptors.request.use(config => {
  config.params = config.params || {};
  config.params['key'] = process.env.VUE_APP_SOLKART_API_KEY;
  return config;
});
